import React from 'react';
import { NavLink } from 'react-router-dom';
import Cta from "../../components/cta/cta";
import Testimonials from "../../components/home/Testimonials";
import beyondStayCheckout from "../../assets/images/homePage/beyondStay-checkout.svg";
import beyondAi from "../../assets/images/homePage/beyondAi.svg";
import beyondConcierge from "../../assets/images/homePage/beyondconcierge.svg";
import beyondCalendar from "../../assets/images/homePage/beyondCalender.svg";
import beyondStayCheckin from "../../assets/images/homePage/beyondStay-checkin.svg";
import beyondMail from "../../assets/images/homePage/beyond_Mail.svg";



function WhatWeOfferPage() {

    const features = [
        {
            title: "BeyondStay – Contactless Check-In",
            description: "Fast, touch-free guest arrivals.",
            icon: beyondStayCheckin,
            link: "/tools/beyond-stay"
        },
        {
            title: "BeyondStay – Contactless Check-Out",
            description: "Hassle-free, digital departures.",
            icon: beyondStayCheckout,
            link: "/tools/beyondstay-checkout"
        },
        {
            title: "Beyond AI – Integrated AI Widget",
            description: "Lead gen, reports, insights—instantly.",
            icon: beyondAi,
            link: "/tools/beyond-ease"
        },
        {
            title: "Beyond Concierge – AI Assistant",
            description: "24/7 virtual guest service.",
            icon: beyondConcierge,
            link: "/tools/beyond-concierge"
        },
        {
            title: "Beyond Calendar",
            description: "AI-powered events and greetings.",
            icon: beyondCalendar,
            link: "/tools/beyond-calendar"
        },
        {
            title: "Beyond Mail",
            description: "Automated, personalized email campaigns.",
            icon: beyondMail,
            link: "/tools/beyond-mail"
        }
    ];

    return (
        <>
            <div style={{ backgroundColor: '#f5f9fc', minHeight: '100vh' }}>
                <div className='max-container'>
                    <div className='padd-90'>

                        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                            <h1
                                className='heading29px roboto-bold text-color-131415' style={{ marginBottom: '8px' }}>AI-Powered Features Built for <br /> <span className='text-primary-color'>Hospitality Workflows</span></h1>
                            <h2 style={{ color: '#4B5563', }} className='heading18px mb20 roboto-regular'>
                                Browse our curated set of smart, scalable solutions
                            </h2>
                            <p style={{ color: '#6B7280' }} className='heading16px mb20 roboto-regular mb40'>
                                BeyondLeadz empowers your hotel with smart automation—streamline guest arrivals and departures using BeyondStay, capture leads and insights with Beyond AI, and deliver 24/7 support through Beyond Concierge. Effortlessly manage events with Beyond Calendar and run personalized email campaigns using Beyond Mail—all designed to enhance efficiency and guest satisfaction.
                            </p>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(290px, 1fr))', gap: '24px' }}>
                                {features.map((feature, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: '#ffffff',
                                            borderRadius: '16px',
                                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                            padding: '24px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            transition: 'box-shadow 0.3s ease'
                                        }}
                                        onMouseEnter={e => (e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)')}
                                        onMouseLeave={e => (e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)')}
                                    >
                                        <div style={{ marginBottom: '16px' }}>
                                            <img src={feature.icon} alt={feature.title} />
                                        </div>

                                        <p style={{
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            marginBottom: '8px',
                                            color: '#111827',
                                            textDecoration: 'none'
                                        }}>
                                            {feature.title}
                                        </p>
                                        <p style={{ color: '#4B5563' }}>{feature.description}</p>

                                        <NavLink className="common-btn-class transparentBtn roboto-regular" style={{ width: '130px', padding: '5px 10px', marginTop: '20px' }} to={feature.link}>Check Now &nbsp; <span>→</span></NavLink>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <Cta
                heading="Take the first step toward smarter hotel management"
                firstCta="/signup"
                firstCtaText="Subscribe Now"
                secondCta="/contact-us"
                secondCtaText="Contact us"
            />

            <Testimonials />
        </>

    );
}

export default WhatWeOfferPage;
